<template>
  <div class="d-flex h-100 flex-column">
    <div class="flex-grow-1 justify-content-end p-3 overflow-auto pretty-scroll-theme" style="height: 1px;"  id="voting_rounds">
      <details open>
        <summary class="justify-content-between align-items-center mb-3" style="border-bottom: 2px solid #9B9F9B">
          <span class="h-5 text-white-50">
            {{ $t("js.voting_rounds.active_rounds") }}
          </span>
          <span class="badge text-bg-info float-end">{{ openRounds.length }}</span>
        </summary>
        <template v-if='openRounds.length > 0'>
          <VotingRound v-for="votingRound in openRounds" :selected="votingRound.id === selectedRound" :votingRound="votingRound" :key="`voting_round_${votingRound.reference}`" :roundState='calculateState(votingRound)' @toggleRound="toggleRound" />
        </template>
        <div v-else class='text-center p-3 text-white-50'>{{ $t("js.voting_rounds.no_active_rounds") }}</div>
      </details>


      <details open>
        <summary class="justify-content-between align-items-center mb-3" style="border-bottom: 2px solid #9B9F9B">
          <span class="h-5 text-white-50">
            {{ $t("js.voting_rounds.scheduled_rounds") }}
          </span>
          <span class="badge text-bg-primary float-end">{{ scheduledRounds.length }}</span>
        </summary>
        <template v-if='scheduledRounds.length > 0'>
          <VotingRound v-for="votingRound in scheduledRounds" :selected="votingRound.id === selectedRound" :votingRound="votingRound" :key="`voting_round_${votingRound.reference}`" :roundState='calculateState(votingRound)' @toggleRound="toggleRound" />
        </template>
      </details>

      <details open>
        <summary class="justify-content-between align-items-center mb-3" style="border-bottom: 2px solid #9B9F9B">
          <span class="h-5 text-white-50">
            {{ $t("js.voting_rounds.inactive_rounds") }}
          </span>
          <span class="badge float-end text-bg-warning" >{{ availableRounds.length }}</span>
        </summary>
        <template v-if='availableRounds.length > 0'>
          <VotingRound v-for="votingRound in availableRounds" :selected="votingRound.id === selectedRound" :votingRound="votingRound" :key="`voting_round_${votingRound.reference}`" :roundState='calculateState(votingRound)' @toggleRound="toggleRound" />
        </template>
        <div v-else class='text-center p-3 text-white-50'>{{ $t("js.voting_rounds.no_inactive_rounds") }} </div>
      </details>

      <details open>
        <summary class="justify-content-between align-items-center mb-3" style="border-bottom: 2px solid #9B9F9B">
          <span class="h-5 text-white-50">
            {{ $t("js.voting_rounds.closed_rounds") }}
          </span>
          <span class="badge text-bg-warning float-end">{{ closedRounds.length }}</span>
        </summary>
        <template v-if='closedRounds.length > 0'>
          <VotingRound v-for="votingRound in closedRounds" :selected="votingRound.id === selectedRound" :votingRound="votingRound" :key="`voting_round_${votingRound.reference}`" :roundState='calculateState(votingRound)' @toggleRound="toggleRound" />
        </template>
      </details>

      <details>
        <summary class="justify-content-between align-items-center mb-3" style="border-bottom: 2px solid #9B9F9B">
          <span class="h-5 text-white-50">
            {{ $t("js.voting_rounds.finished_rounds") }}
          </span>
          <span class="badge text-bg-success float-end">{{ finishedRounds.length }}</span>
        </summary>
        <template v-if='finishedRounds.length > 0'>
          <VotingRound v-for="(votingRound, index) in finishedRounds" :selected="votingRound.id === selectedRound" :votingRound="votingRound" :key="`voting_round_${votingRound.reference}_${index}`" :roundState='calculateState(votingRound)' @toggleRound="toggleRound" />
        </template>
      </details>

      <details>
        <summary class="justify-content-between align-items-center mb-3" style="border-bottom: 2px solid #9B9F9B">
          <span class="h-5 text-white-50">
            {{ $t("js.voting_rounds.archived_rounds") }}
          </span>
          <span class="badge text-bg-warning float-end">{{ archivedRounds.length }}</span>
        </summary>
        <template v-if='archivedRounds.length > 0'>
          <VotingRound v-for="(votingRound, index) in archivedRounds" :selected="votingRound.id === selectedRound" :votingRound="votingRound" :key="`voting_round_${votingRound.reference}_${index}`" :roundState='calculateState(votingRound)' @toggleRound="toggleRound" />
        </template>
      </details>

    </div>
  </div>

</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { calculateState } from "../../entrypoints/shared/voting_rounds_helper.js";
import VotingRound from "./VotingRound.vue"

  export default {
    name: 'VotingRounds',
    components: {VotingRound},
    props: {
      selectedRound: null,
    },
    computed: {
      ...mapState(["votingRounds", "votingRoundReports", "chatUser", "voting"]),
      ...mapGetters(['firstAvailableLocale']),
      closedRounds(){
        return this.votingRounds.filter(vr => ["closed", "past"].includes(calculateState(vr, this.fetchVotingRoundReport(vr))))
      },
      scheduledRounds(){
        return this.votingRounds.filter(vr => ["future"].includes(calculateState(vr, this.fetchVotingRoundReport(vr))))
      },
      availableRounds() {
        return this.votingRounds.filter(vr => ["available"].includes(calculateState(vr)))
      },
      openRounds(){
        return this.votingRounds.filter(vr => ["open", "active"].includes(calculateState(vr)))
      },
      finishedRounds(){
        return this.votingRounds.filter(vr => ["finished"].includes(calculateState(vr, this.fetchVotingRoundReport(vr))))
      },
      archivedRounds() {
        return this.votingRounds.filter(vr => ["archived"].includes(calculateState(vr, this.fetchVotingRoundReport(vr))))
      }
    },
    methods: {
      calculateState,
      toggleRound(votingRoundId){
        this.$emit("toggleRound", votingRoundId)
      },
      fetchVotingRoundReport(vr) {
        return this.votingRoundReports.find(vrr => vrr.votingRoundReference === vr.reference);
      }
    }
  }
</script>
